import { __rest, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import KModalHeader from '../../KModal/KModalHeader/index.js';

var DownloadManagerHeader = function (_a) {
    var selection = _a.selection, className = _a.className, id = _a.id, _b = _a.testId, testId = _b === void 0 ? "DownloadManagerHeader" : _b, rest = __rest(_a, ["selection", "className", "id", "testId"]);
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(KModalHeader, __assign({ id: id, testId: testId, title: t("components.downloadManager.header.title", {
            count: selection.length
        }), className: clsx("DownloadManagerHeader", className) }, rest)));
};

export { DownloadManagerHeader as default };
//# sourceMappingURL=index.js.map
